import { SITE_ORIGIN } from 'constants';
import routes from 'constants/routes';

export const DEMO_TITLE = 'Kostenlose Demo buchen | FOXI';

export const DEMO_DESCRIPTION =
  'Buche eine kostenlose, unverbindliche Demo von FOXI – der KI-Software für Abrechnung und Dokumentation in der Zahnarztpraxis.';

export const DEMO_URL = `${SITE_ORIGIN}${routes.demo}`;

/**
 * Structured data for the demo booking page. References the nodes defined on
 * the start page (see pages/HomeV2/seo.js) instead of duplicating them.
 */
export const demoStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${DEMO_URL}#webpage`,
  url: DEMO_URL,
  name: DEMO_TITLE,
  description: DEMO_DESCRIPTION,
  inLanguage: 'de-DE',
  isPartOf: { '@id': `${SITE_ORIGIN}/#website` },
  about: { '@id': `${SITE_ORIGIN}/#software` },
  publisher: { '@id': `${SITE_ORIGIN}/#organization` },
};
